import * as React from 'react';
import './ArticleImage.scss';
import { childClassClosure, ClassableProps, baseClassAnd } from '@jcharlesworthuk/your-mum-core/dist/functions';
import { Property } from 'csstype';

const baseClass = 'article-image';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
    src: string,
    alt: string,
    /**
     * Generally use height for svgs and maxHeight for png/jpgs
     */
    imgHeight?: string | number,
    imgMaxHeight?: string | number,

    /**
     * Generally use width for smaller images you don't want to fill the width of the screen
     */
    imgWidth?: string | number,
    imgMaxWidth?: string | number,

    float?: Property.Float;

    annotation?: string;

    flipReverse?: boolean;
}

const ArticleImage: React.FunctionComponent<Props> = (props: Props) => {
    const imageStyleObject: React.CSSProperties = {
        height: props.imgHeight,
        maxHeight: props.imgMaxHeight,
        width: props.imgWidth,
        maxWidth: props.imgMaxWidth || '100%',
        margin: props.imgMaxWidth ? 'auto' : undefined
    };
    const divStyleObject: React.CSSProperties = {
        float: props.float
    };
    return <div className={baseClassAnd(baseClass, props, props.flipReverse ? 'flip-reverse' : '')} style={divStyleObject}>
        {props.annotation ? <>
            <p className={childClass('annotation')}>{props.annotation}</p>
            <div className={childClass('img-block')}>
                <img className={childClass('img', 'annotated')} src={props.src} alt={props.src} style={imageStyleObject} />
            </div>
        </>
            : <img className={childClass('img')} src={props.src} alt={props.src} style={imageStyleObject} />}
    </div>
}
export default ArticleImage;
